<div class="login-wrapper">
  <div class="red-part">
    <div class="logo">
      <img class="logo-img" src="/assets/images/login/Logo.svg" alt="" />
    </div>
    <div class="main-text">
      <img src="/assets/images/login/main-logo-text.svg" alt="" />
    </div>
  </div>
  <div class="white-part">
    <router-outlet></router-outlet>
  </div>
</div>

